// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ContainersGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#containers-gradient_svga)"
      d="M19.98 30.9 7.7 21.35 5 23.45l15 11.67 15-11.67-2.72-2.12zm.02-4.23 12.27-9.55L35 15 20 3.33 5 15l2.72 2.12z"
    />
    <defs>
      <linearGradient
        id="containers-gradient_svga"
        x1={5}
        x2={37.42}
        y1={3.33}
        y2={32.42}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "ContainersGradient",
);
export default ContainersGradientIcon;
